module.exports = __webpack_public_path__ + "img/safari.81b2b035.svg";